import {
  McpServerConnectionCreateInput,
  McpServerConnectionListResult,
  McpServerConnectionProbeResult,
  McpServerConnectionSafe,
  McpServerConnectionUpdateInput,
} from '@vivport/backend/types';
import { httpClient } from './http-client';

export async function listMcpServerConnections(): Promise<McpServerConnectionListResult> {
  return httpClient.get<McpServerConnectionListResult>('/protected/mcp-server-connections/');
}

export async function createMcpServerConnection(
  input: McpServerConnectionCreateInput
): Promise<McpServerConnectionSafe> {
  return httpClient.post<McpServerConnectionSafe>('/protected/mcp-server-connections/', input);
}

export async function updateMcpServerConnection(
  id: number,
  input: McpServerConnectionUpdateInput
): Promise<McpServerConnectionSafe> {
  return httpClient.patch<McpServerConnectionSafe>(`/protected/mcp-server-connections/${id}`, input);
}

export async function deleteMcpServerConnection(id: number): Promise<void> {
  return httpClient.delete<void>(`/protected/mcp-server-connections/${id}`);
}

export async function pinMcpServerConnection(id: number): Promise<McpServerConnectionSafe> {
  return httpClient.post<McpServerConnectionSafe>(`/protected/mcp-server-connections/${id}/pin`);
}

export async function probeMcpServerConnection(id: number): Promise<McpServerConnectionProbeResult> {
  return httpClient.post<McpServerConnectionProbeResult>(`/protected/mcp-server-connections/${id}/probe`);
}
